import { useState } from 'react'
import { toast } from 'react-toastify'
import { useMutation } from 'urql'

import IconPlus from '@/assets/icons/ic_logic-g-app_plus.svg'
import { graphql } from '@/gql/generated'
import { iso8601DateString } from '@/utils/date-helpers'

import {
  SchoolCodeRegistrationFormData,
  SchoolCodeRegistrationModal,
} from '../modal/SchoolCodeRegistrationModal'
import { Button } from '../ui/button'

enum EModal {
  None,
  SchoolCodeRegistrationModal,
}

export const SchoolCodeRegistration = (): JSX.Element => {
  const [modal, setModal] = useState<EModal>(EModal.None)

  const [, bindSchoolStudentMutation] = useMutation(SchoolStudentBindMutatiton)

  const onSubmit = async (formdata: SchoolCodeRegistrationFormData) => {
    const { error, data } = await bindSchoolStudentMutation({
      input: {
        schoolCode: formdata.schoolCode,
        verification: {
          memberId: formdata.verificationMemberId,
          birthdate: formdata.verificationBirthdate
            ? iso8601DateString(new Date(formdata.verificationBirthdate))
            : null,
        },
      },
    })

    if (error || data?.schoolStudentBind?.errors?.length) {
      toast.error('メンバーの紐づけに失敗しました', {
        toastId: 'student-bind-failed',
        position: 'bottom-right',
      })
    } else {
      toast.success('メンバーを紐づけました', {
        toastId: 'student-bind-successfully',
        position: 'bottom-right',
      })
    }

    setModal(EModal.None)
  }

  return (
    <>
      <Button
        variant="light"
        className="mx-auto mt-[44px] flex h-[70px] w-[338px] bg-white text-[16px] font-bold shadow-tiny md:text-[20px]"
        onClick={() => setModal(EModal.SchoolCodeRegistrationModal)}
      >
        <IconPlus width={30} height={30} className="h-[36px] w-[36px] md:h-[40px] md:w-[40px]" />
        スクールコードを入力
      </Button>

      <SchoolCodeRegistrationModal
        isOpen={modal === EModal.SchoolCodeRegistrationModal}
        onRequestClose={() => setModal(EModal.None)}
        onOk={onSubmit}
      />
    </>
  )
}

const SchoolStudentBindMutatiton = graphql(`
  mutation SchoolStudentBindMutatiton($input: SchoolStudentBindInput!) {
    schoolStudentBind(input: $input) {
      schoolUser {
        id
      }
      currentUser {
        ... on User {
          id
          schoolUsers {
            id
          }
          players {
            id
          }
        }
      }

      errors {
        ... on BaseError {
          __typename
          field
        }
      }
    }
  }
`)
